import { render, staticRenderFns } from "./SculpturesOtherCriticisms.vue?vue&type=template&id=19554bde&scoped=true&"
import script from "./SculpturesOtherCriticisms.vue?vue&type=script&lang=js&"
export * from "./SculpturesOtherCriticisms.vue?vue&type=script&lang=js&"
import style0 from "./SculpturesOtherCriticisms.vue?vue&type=style&index=0&id=19554bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19554bde",
  null
  
)

export default component.exports